import styled from "styled-components/macro";
import { DeviceType } from "../../utils/hooks/useDeviceHook";
import { HELP_DESKTOP_MEDIA } from "../Help/Help.constants";

export const ContactUsPageWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const getContactUsWidth = (deviceType: DeviceType) => {
  if (deviceType === "desktop") {
    return "minmax(0, 1fr) minmax(260px, 330px)";
  }
  if (deviceType === "tablet") {
    return "570px";
  }
  return "360px";
};

const getContactUsPadding = (deviceType: DeviceType) => {
  if (deviceType === "desktop") {
    return "90px clamp(24px, 8vw, 142px) 142px";
  }
  if (deviceType === "tablet") {
    return "60px 18px 80px 18px";
  }
  return "40px 0px 92px 0px";
};

export const ContactUsComponentWrapper = styled.div<{
  deviceType: DeviceType;
}>`
  display: grid;
  width: ${({ deviceType }) => (deviceType === "desktop" ? "100%" : undefined)};
  max-width: ${({ deviceType }) =>
    deviceType === "desktop" ? "1438px" : undefined};
  box-sizing: border-box;
  grid-template-columns: ${({ deviceType }) => getContactUsWidth(deviceType)};
  padding: ${({ deviceType }) => getContactUsPadding(deviceType)};
  grid-column-gap: ${({ deviceType }) =>
    deviceType === "desktop" ? "24px" : undefined};

  @media (${HELP_DESKTOP_MEDIA}) {
    [data-help-panel-open="true"] & {
      max-width: 960px;
      grid-template-columns: minmax(0, 802px);
      justify-content: center;
      row-gap: 32px;
      padding: 60px clamp(24px, 5vw, 72px) 96px;
    }
  }
`;

export const ContactUsComponentContentWrapper = styled.div<{
  deviceType: DeviceType;
}>`
  display: grid;
  grid-template-rows: ${({ deviceType }) =>
    deviceType === "desktop" ? "40px auto" : "40px auto auto"};
  grid-column-gap: ${({ deviceType }) =>
    deviceType === "desktop" ? "24px" : undefined};
`;

export const ContactUsPageTitleWrapper = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const ContactUsPageDesktopRightWrapper = styled.div<{
  deviceType: DeviceType;
}>`
  display: grid;
  grid-template-rows: ${({ deviceType }) =>
    deviceType === "desktop" ? "40px 268px 420px" : "70px 268px 420px"};

  .contact-us-connect {
    line-height: 60px !important;
  }

  @media (${HELP_DESKTOP_MEDIA}) {
    [data-help-panel-open="true"] & {
      grid-template-rows: 40px auto;
    }
  }
`;

export const ContactUsGeneralContainer = styled.div<{ padding: string }>`
  margin-top: 20px;
  padding: ${({ padding }) => padding};
  background-color: ${({ theme }) => theme.white};
  box-shadow: ${({ theme }) => theme.boxShadow};
  width: 100%;
  max-width: 802px;
  box-sizing: border-box;
`;
